(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (() => {
    const container = document.querySelector('[data-customer-addresses]');
    if (!container) return;

    container.querySelectorAll('button[aria-expanded]').forEach((button) => {
      button.addEventListener('click', () => {
        const panel = document.getElementById(button.getAttribute('aria-controls') || '');
        if (!panel) return;

        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        panel.hidden = expanded;
      });
    });

    container.querySelectorAll('button[type="reset"]').forEach((button) => {
      button.addEventListener('click', () => {
        const addressContainer = button.closest('[data-address]');
        const toggle = addressContainer?.querySelector('button[aria-expanded]');
        const panel = addressContainer?.querySelector('.customer-addresses__form-panel');
        toggle?.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (() => {
    const container = document.getElementById('CustomerLogin');
    if (!container) return;

    const toggleRecover = (showRecover) => {
      container.classList.toggle('customer-form--recover', showRecover);
    };

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLAnchorElement)) return;

      if (target.getAttribute('href') === '#recover') {
        event.preventDefault();
        toggleRecover(true);
      }

      if (target.getAttribute('href') === '#login') {
        event.preventDefault();
        toggleRecover(false);
      }
    });

    if (window.location.hash === '#recover') {
      toggleRecover(true);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
